// ─────────────────────────────────────────────
//  RecentImportsList — the last few applied imports, restorable.
//
//  Anesthesia Team Control (ATC)
//  Copyright © 2026 Gonzalo Martinez (gamc00@gmail.com). All rights reserved.
//  Proprietary and confidential. Not licensed for public use — see /LICENSE.
// ─────────────────────────────────────────────
//
//  ⚠️ CLICKING RESTORES A STORED SNAPSHOT, IT DOES NOT RE-FETCH THE SHEET. The
//  department renames one file in place every day, so "re-run yesterday" against
//  the live API would silently read TODAY'S grid and stage the wrong day. The
//  title text says so, and this component never touches the network.
//
//  Presentational and controlled — the parent owns the records and the restore.
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { color } = tokens;

const SOURCE_BADGE = {
  "global-sheet": "GLOBAL",
  "scheduled-internal": "AUTO · INTERNAL",
  scheduled: "AUTO",
};

export default function RecentImportsList({ records = [], onRestore, title = "Recent global imports" }) {
  if (!records.length) return null;
  return (
    <div style={st.wrap}>
      <div style={st.title}>{title}</div>
      <div style={st.list}>
        {records.map((rec) => (
          <button
            key={rec.id}
            type="button"
            onClick={() => onRestore && onRestore(rec)}
            title="Restore this import's saved snapshot (no live sheet fetch)"
            style={st.row}
          >
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={st.name}>{rec.filename || "Global sheet"}</span>
              <span style={st.date}>{rec.dateKey || ""}</span>
            </span>
            <span style={st.badge}>{SOURCE_BADGE[rec.source] || "AUTO"}</span>
            <span style={st.cta}>Restore →</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const st = {
  wrap: { marginTop: 12, borderTop: `1px solid ${color.border.default}`, paddingTop: 10 },
  title: {
    fontSize: 11, fontWeight: 800, color: color.text.muted,
    textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 6,
  },
  list: { display: "flex", flexDirection: "column", gap: 6 },
  row: {
    display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left",
    background: color.surface.raised, border: `1px solid ${color.border.default}`,
    borderRadius: 8, padding: "8px 12px", cursor: "pointer", fontFamily: "inherit",
  },
  name: {
    display: "block", fontSize: 13, fontWeight: 700, color: color.text.primary,
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
  },
  date: { fontSize: 11, color: color.text.muted },
  badge: {
    fontSize: 10, fontWeight: 800, color: color.accent.primary,
    border: `1px solid ${color.accent.primary}`, borderRadius: 9999,
    padding: "2px 8px", whiteSpace: "nowrap",
  },
  cta: { fontSize: 11, fontWeight: 700, color: color.accent.primary, whiteSpace: "nowrap" },
};
